import { compose, lifecycle } from 'recompose'

import { setWrapDisplayName } from 'hoc/setWrapDisplayName'

export const withComponentDidUpdate = componentDidUpdateFn => BaseComponent =>
  compose(
    setWrapDisplayName(BaseComponent, 'withComponentDidUpdate'),
    lifecycle({
      componentDidUpdate(prevProps) {
        componentDidUpdateFn(this.props, prevProps)
      },
    }),
  )(BaseComponent)
